const DashboardTopOrgsCard = ({
  icon,
  title,
  type = "array",
  items,
  backgroundColor = "#5153F5",
}) => {
  return (
    <div className="h-full w-full rounded-2xl border border-gray-200 bg-white shadow-sm">
      <div
        style={{
          backgroundColor: backgroundColor,
        }}
        className="flex flex-row justify-start items-center border-b border-gray-200 rounded-t-2xl px-4 pb-4 pt-4"
      >
        {icon}
        <h6 className="text-base font-semibold text-white">{title}</h6>
      </div>

      <div className="flex flex-col items-start justify-between px-4 py-4">
        {items?.length > 0 &&
          items?.map((item, index) => (
            <div
              key={`${item?.type}-${index}`}
              className="border border-slate-300 rounded-xl px-2 py-2 flex flex-row w-full justify-center items-center mb-1"
            >
              <p className="text-base font-medium w-4/6">
                {item?.company_name ??
                  item?.manager_id?.firstname ??
                  "Unnamed Team"}
              </p>

              <p className="font-semibold text-right text-base w-2/6">
                {item?.usedSeats ?? 0} / {item?.seats ?? 0} Seats Used
              </p>
            </div>
          ))}
      </div>
    </div>
  );
};

export default DashboardTopOrgsCard;
